import { Button, Col, Row } from "antd";
import Title from "antd/lib/typography/Title";
import * as React from "react";
import FormLabel from "../../../core/ui/components/FormLabel";
import { DataGrid } from "@core-ui/datagrid";
import { TOrganisationIndexPresentationModel } from "../../presenter/model/OrganisationIndexPresentationModel";
import OrganisationIndexTag from "./OrganisationIndexTag";
import { ICaseLawDocument } from "../../../caseLawDocuments/model/CaseLawDocument";
import { IOrganisationIndex } from "../../model/OrganisationIndex";

const IndexData = ({
  translate,
  connectedIndexes,
  indexInfoVisible,
  findConnectionCandidatesForIndex,
  clickedIndex,
  changeUpdateIndexModalVisible,
  canEdit,
  getCaseLawDocumentsForIndex,
  getSwitchGroupCandidates,
  connectedIndexesByCategory
}: {
  translate;
  connectedIndexes?: TOrganisationIndexPresentationModel[];
  indexInfoVisible: boolean;
  findConnectionCandidatesForIndex: any;
  clickedIndex: TOrganisationIndexPresentationModel;
  changeUpdateIndexModalVisible: any;
  canEdit: any;
  getCaseLawDocumentsForIndex: any;
  removeOrganisationIndex: any;
  caseLawDocuments?: ICaseLawDocument[];
  getSwitchGroupCandidates: any;
  connectionCandidatesByCategory?: IOrganisationIndex[];
  changeIndexesByCategoryModalVisible?: any;
  findConnectionCandidatesByCategory?: any;
  indexesByCategoryModalVisible?: any;
  connectedIndexesByCategory: IOrganisationIndex[];
}) => {
  const columns = [
    {
      title: translate("editors.organisation_indexes.organisation"),
      key: "organisation",
      dataIndex: ["organisation", "name"]
    },
    {
      title: translate("editors.organisation_indexes.descriptor"),
      key: "name",
      dataIndex: "name",
      render: (text, data: TOrganisationIndexPresentationModel) => (
        <div>
          {data?.pathToIndex?.length > 0 ? (
            <OrganisationIndexTag
              indexHierarchyList={data?.pathToIndex || []}
              style={{ justifyContent: "flex-start", width: "20em" }}
            />
          ) : (
            <OrganisationIndexTag
              indexHierarchyList={[data?.name]}
              style={{ justifyContent: "flex-start", width: "20em" }}
            />
          )}
        </div>
      )
    }
  ];

  const showConnectedIndexes = () => {
    return (
      connectedIndexes &&
      connectedIndexes?.length > 0 && (
        <div>
          {showTable(
            connectedIndexes,
            translate("editors.organisation_indexes.connected_indexes")
          )}
        </div>
      )
    );
  };

  const showConnectedIndexesByCategory = () => {
    return (
      connectedIndexesByCategory &&
      connectedIndexesByCategory?.length > 0 && (
        <div>
          {showTable(
            connectedIndexesByCategory,
            translate("editors.organisation_indexes.indexes_by_category")
          )}
        </div>
      )
    );
  };

  const showTable = (list, label) => {
    return (
      list &&
      list?.length > 0 && (
        <div style={{ marginTop: "2em" }}>
          <div
            style={{
              marginBottom: "0.5em"
            }}
          ></div>
          <DataGrid
            tableFormManager={{
              columns: columns,
              dataSource: list,
              keyProperty: "id",
              locale: {}
            }}
            headerFormManager={{
              title: label
            }}
            searchFormManager={{
              searchEnabled: false,
              searchTablePlaceholder: "",
              searchFunction: null
            }}
            pagingFormManager={{
              dataSource: list,
              itemsPerPageLabel: "",
              showingLabel: translate(
                "editors.organisation_indexes.showing_label"
              ),
              totalLabel: translate("editors.organisation_indexes.total_label"),
              toLabel: translate("editors.organisation_indexes.to_label"),
              pageSize: 10
            }}
            deleteModalFormManager={{}}
            createModalFormManager={{}}
            updateModalFormManager={{}}
          />
        </div>
      )
    );
  };

  return indexInfoVisible ? (
    <div className="index-details">
      <Row justify="space-between">
        <Col span={16}>
          <Title level={2}>
            {translate("editors.organisation_indexes.details")}
          </Title>
        </Col>
        {canEdit() && (
          <Col span={8}>
            <Button
              danger
              onClick={() => getCaseLawDocumentsForIndex(clickedIndex)}
              style={{ float: "right", marginRight: "1em" }}
              type="primary"
            >
              {translate("editors.case_law_documents.remove")}
            </Button>
            <Button
              onClick={() => changeUpdateIndexModalVisible(true)}
              style={{ float: "right", marginRight: "1em" }}
              type="primary"
            >
              {translate("editors.case_law_documents.update")}
            </Button>
          </Col>
        )}
      </Row>
      <FormLabel text={translate("editors.organisation_indexes.descriptor")} />
      <div>
        {clickedIndex.pathToIndex ? (
          <OrganisationIndexTag
            indexHierarchyList={clickedIndex.pathToIndex || []}
            style={{ marginBottom: "2em" }}
          />
        ) : (
          <OrganisationIndexTag
            indexHierarchyList={[clickedIndex.name] || []}
            style={{ marginBottom: "2em" }}
          />
        )}
      </div>
      <div>
        <div>
          <FormLabel text={translate("editors.organisation_indexes.type")} />
          <p>{clickedIndex.indexType?.name}</p>
        </div>
        <div>
          <FormLabel
            text={translate("editors.organisation_indexes.organisation")}
          />
          <p>{clickedIndex.organisation?.name}</p>
        </div>
        {canEdit() && !clickedIndex?.harmonized && (
          <Button
            onClick={() => findConnectionCandidatesForIndex(clickedIndex)}
            style={{ marginTop: "0.5em" }}
          >
            {translate("editors.organisation_indexes.show_candidates")}
          </Button>
        )}
        {canEdit() && (
          <Button
            onClick={() => getSwitchGroupCandidates()}
            style={{ marginTop: "0.5em" }}
          >
            {translate("editors.organisation_index_groups.switch_group")}
          </Button>
        )}
      </div>
      {showConnectedIndexesByCategory()}
      {showConnectedIndexes()}
    </div>
  ) : (
    <div></div>
  );
};

export default IndexData;
